var map = {
	"./ABABank.png": 857,
	"./ABNAMRO.png": 858,
	"./Advcash.png": 859,
	"./AirTM.png": 860,
	"./AirtelMoney.png": 861,
	"./Alfa-bank.png": 862,
	"./Alipay.png": 863,
	"./ApplePay.png": 864,
	"./BBVA.png": 865,
	"./BBVAUruguay.png": 866,
	"./BCAMobile.png": 867,
	"./BMO.png": 868,
	"./BNPParibas.png": 869,
	"./Bakong.png": 870,
	"./Bancamiga.png": 871,
	"./BancoBrubank.png": 872,
	"./BancoContinentalParaguay.png": 873,
	"./BancoEstado.png": 874,
	"./BancoFassil.png": 875,
	"./BancoGNBParaguay.png": 876,
	"./BancoGanadero.png": 877,
	"./BancoGeneralPanama.png": 878,
	"./BancoGuayaquil.png": 879,
	"./BancoItauParaguay.png": 880,
	"./BancoPichincha.png": 881,
	"./BancoSantanderChile.png": 882,
	"./BancoSantanderUruguay.png": 883,
	"./BancoUnion.png": 884,
	"./BancodeBogota.png": 885,
	"./BancodeChile.png": 886,
	"./Bancolombia.png": 887,
	"./BancolombiaS.A.png": 888,
	"./BandesUruguay.png": 889,
	"./Banesco.png": 890,
	"./BanescoPanama.png": 891,
	"./BanistmoPanama.png": 892,
	"./BankTransfer.png": 893,
	"./BankTransferArgentina.png": 894,
	"./BankTransferBrazil.png": 895,
	"./BankTransferIndia.png": 896,
	"./BankTransferTaiwan.png": 897,
	"./BankTransferVenezuela.png": 898,
	"./BankofAmerica.png": 899,
	"./BankoftheRepublicofUrugua.png": 900,
	"./Bankslip.png": 901,
	"./BarclaysBank.png": 902,
	"./Blik.png": 903,
	"./Bundle.png": 904,
	"./CIBC.png": 905,
	"./CSOB.png": 906,
	"./CaissedEpargne.png": 907,
	"./CashDeposittoBank.png": 908,
	"./CashU.png": 909,
	"./Cashapp.png": 910,
	"./CashinPerson.png": 911,
	"./CenterCreditBank.png": 912,
	"./Ceskasporitelna.png": 913,
	"./ChipperCash.png": 914,
	"./CitibankRussia.png": 915,
	"./Coinpay.png": 916,
	"./CreditAgricole.png": 917,
	"./CreditBankofMoscow.png": 918,
	"./CreditBankofPeru.png": 919,
	"./DANA.png": 920,
	"./DCBank.png": 921,
	"./Daviplata.png": 922,
	"./Davivienda.png": 923,
	"./DaviviendaS.A.png": 924,
	"./EQBank.png": 925,
	"./EasyPay.png": 926,
	"./Easypaisa-PKOnly.png": 927,
	"./Efecty.png": 928,
	"./FNB-ewallet.png": 929,
	"./FasterPaymentSystem.png": 930,
	"./FasterPaymentSystemFPS.png": 931,
	"./Fiobanka.png": 932,
	"./ForteBank.png": 933,
	"./G-Money.png": 934,
	"./GEOPay.png": 935,
	"./Garanti.png": 936,
	"./Gazprombank.png": 937,
	"./Gcash.png": 938,
	"./GoMoney.png": 939,
	"./GoPay.png": 940,
	"./GooglePay.png": 941,
	"./GooglePayGPay.png": 942,
	"./GrabPay.png": 943,
	"./HalykBank.png": 944,
	"./HomeCreditKazakhstan.png": 945,
	"./IMPS.png": 946,
	"./INGHollandonly.png": 947,
	"./Interace-Transfer.png": 948,
	"./InternationalWireSWIFT.png": 949,
	"./IntesaSanpaolo.png": 950,
	"./ItauBrazil.png": 951,
	"./ItauUruguay.png": 952,
	"./JKOPAY.png": 953,
	"./Jazzcash.png": 954,
	"./JeniusPayMe.png": 955,
	"./KBZPay.png": 956,
	"./KaspiBank.png": 957,
	"./KuveytTurk.png": 958,
	"./LCL.png": 959,
	"./LINEPay.png": 960,
	"./LaBanquepostale.png": 961,
	"./LinkAja.png": 962,
	"./LloydsBank.png": 963,
	"./M-PESAKenyaSafaricom.png": 964,
	"./M-pesaPaybill.png": 965,
	"./MONETAMoneyBank.png": 966,
	"./MTNMoMo.png": 967,
	"./MTS-Bank.png": 968,
	"./MandiriPay.png": 969,
	"./Mercadopago.png": 970,
	"./Mercantil.png": 971,
	"./MercantilBankPanama.png": 972,
	"./Millenium.png": 973,
	"./Mir.png": 974,
	"./MoMo.png": 975,
	"./Mobikwik.png": 976,
	"./Mobiletop-up.png": 977,
	"./Moneygram.png": 978,
	"./Monobank.png": 979,
	"./Mony.png": 980,
	"./Movii.png": 981,
	"./NETELLER.png": 982,
	"./NGNfiatbalance.png": 983,
	"./Nequi.png": 984,
	"./OTP.png": 985,
	"./OVO.png": 986,
	"./OXXO.png": 987,
	"./Oschadbank.png": 988,
	"./Otkritie.png": 989,
	"./PUMB.png": 990,
	"./PagSeguro.png": 991,
	"./PagoMovil.png": 992,
	"./Papara.png": 993,
	"./PayMe.png": 994,
	"./PayNow.png": 995,
	"./PayPal.png": 996,
	"./Payall.png": 997,
	"./Payeer.png": 998,
	"./Paylah.png": 999,
	"./Paymaya.png": 1000,
	"./Paynet.png": 1001,
	"./Paysend.com.png": 1002,
	"./Paysend.png": 1003,
	"./Paytm.png": 1004,
	"./PerfectMoney.png": 1005,
	"./PhonePe.png": 1006,
	"./PicPay.png": 1007,
	"./Plin.png": 1008,
	"./PostBank.png": 1009,
	"./Prex.png": 1010,
	"./PrivatBank.png": 1011,
	"./Produbanco.png": 1012,
	"./Provincial.png": 1013,
	"./QIWI.png": 1014,
	"./RBCRoyalBank.png": 1015,
	"./RUBfiatbalance.png": 1016,
	"./Raiffeisenbank.png": 1017,
	"./Revolut.png": 1018,
	"./Rocketbank.png": 1019,
	"./Rosbank.png": 1020,
	"./Rosselkhozbank.png": 1021,
	"./RussianStandardBank.png": 1022,
	"./SBP-FastBankTransfer.png": 1023,
	"./SEPAEUbanktransfer.png": 1024,
	"./STP.png": 1025,
	"./SantanderPoland.png": 1026,
	"./Sberbank.png": 1027,
	"./ScotiabankPeru.png": 1028,
	"./ScotiabankUruguay.png": 1029,
	"./ShopeePay-SEA.png": 1030,
	"./ShopeeTaiwan.png": 1031,
	"./SkrillMoneybookers.png": 1032,
	"./SocieteGenerale.png": 1033,
	"./Sovkombank.png": 1034,
	"./TDBank.png": 1035,
	"./Tangerinebank.png": 1036,
	"./TigoCash.png": 1037,
	"./TigoMoney.png": 1038,
	"./Tinkoff.png": 1039,
	"./TouchnGo.png": 1040,
	"./Transferswithspecificbank.png": 1041,
	"./Transferwise.png": 1042,
	"./TrueMoney.png": 1043,
	"./Trust.png": 1044,
	"./UPI.png": 1045,
	"./Uala.png": 1046,
	"./UniCredit.png": 1047,
	"./Upaisa.png": 1048,
	"./Uphold.png": 1049,
	"./VTBBank.png": 1050,
	"./Venmo.png": 1051,
	"./ViettelPay.png": 1052,
	"./VodafoneCash.png": 1053,
	"./Vodafonecash.png": 1054,
	"./WavePay.png": 1055,
	"./WeChat.png": 1056,
	"./WesternDiscountBank.png": 1057,
	"./WesternUnion.png": 1058,
	"./WingCambodia.png": 1059,
	"./WorldRemit.png": 1060,
	"./YandexMoney.png": 1061,
	"./Yap.png": 1062,
	"./YapBNI.png": 1063,
	"./Yape.png": 1064,
	"./ZaloPay.png": 1065,
	"./Zelle.png": 1066,
	"./Ziraat.png": 1067,
	"./mBank.png": 1068
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 344;